import DestinationsExplorer from './DestinationsExplorer';

export default DestinationsExplorer;
